import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { AppConstant } from '@app/util/app-constants';
import { CreateProjectService } from '../../../../../../shared/services/create-project/create-project.service';
import { RolesSharedService } from '../../../services/roles-shared.service';
import { ServiceProvidersService } from '../../../services/service-providers.service';

@Component({
  selector: 'app-analyst-search-filters',
  templateUrl: './analyst-search-filters.component.html',
  styleUrls: ['./analyst-search-filters.component.css']
})
export class AnalystSearchFiltersComponent implements OnInit {

  @Input() searchResults: any;
  @Output() analystSearchResults: EventEmitter<any> = new EventEmitter<any>();

  searchString = "";
  analystData = [];
  selectedShowOptions = [];
  selectedServiceOptions = [];
  selectedMarketOptions = [];
  selectedIndustryOptions = [];
  selectedFocusAreaOptions = [];
  isCollapsed: boolean[] = [false, false, false, false];
  ratings: number[] = [4, 3, 2, 1, 0];
  selectedRatings: number[];
  isButtonClicked = false;
  isUserSignedIn: boolean;
  searchItems: any;
  latestRating: any;
  spServiceOptions: any;
  searchItemsRes: any;
  searchItemsQuery: any;
  searchResultsEmpty: boolean;
  limitCount: number;
  selectedServiceTypeId: any;
  searchItemsDefault = {
  };
  isViewAllFromDashboardSelected = false;
  isSubHeaderMenuSelected = false;
  dashboardSearchClicked = true;
  isSp = false;

  serviceOptions: any;
  marketOptions: any;
  industryOptions: any;
  focusAreaOptions: any;
  isEmpty=true; 
  public selectedFilters = {
    market: [],
    industry: [],
    focusArea: [],
    service: []
  };

  //See more checkboxes
  seeMoreServices = false;
  seeMoreMarkets = false;
  seeMoreIndustries = false;
  seeMoreFocusAreas = false;
  filteredAnalystList = [];
  allSearchResults = [];

  constructor(public rolesSharedService: RolesSharedService,
    private loaderService: LoaderService,
    private createProjectService: CreateProjectService,
    private authService: AuthenticationService,
    private serviceProvidersService: ServiceProvidersService,
    public router: Router) { }

  ngOnInit() {
    this.limitCount = AppConstant.limit;
    this.serviceProvidersService.searchItemObservable.subscribe(
      resp => {
        this.searchItems = resp;
      }
    );
    this.searchItems.serviceId = [];
    this.searchItems.marketId = [];
    this.searchItems.industryId = [];
    this.searchItems.focusAreaId = [];
    this.getServiceList();
    this.getMarketList();
    this.getIndustryList();
    this.getFocusAreaList();
    this.allSearchResults = this.searchResults;
    this.filteredAnalystList = this.searchResults
  }

  getServiceList() {
    this.createProjectService.getServiceList(this.searchString).subscribe((data: any) => {
      this.serviceOptions = data;
    });
  }
  getMarketList() {
    this.createProjectService.getAvailableAnalystMarketList().subscribe((data: any) => {
      this.marketOptions = data['marketList'];
    });
  }

  getIndustryList() {
    this.createProjectService.getIndustryList(this.searchString).subscribe((data: any) => {
      this.industryOptions = data;
    });
  }

  getFocusAreaList() {
    this.createProjectService.getFocusAreaList(this.searchString).subscribe((data: any) => {
      this.focusAreaOptions = data;
    });
  }
  isCollapseClicked(num) {
    this.isCollapsed[num] = !this.isCollapsed[num];
  }

  onMarketChange(event, marketId) {
    this.searchItems.limit = this.limitCount;
    this.searchItems.offset = 0;
    this.searchItems.offset = 0;
    if (event) {
      this.searchItems.marketId.push(marketId);
      this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
        resp => {
          this.analystSearchResults.emit(resp);
        }
      );
    } else {
      const index = this.searchItems.marketId.indexOf(marketId);
      if (index >= 0) {
        this.searchItems.marketId.splice(index, 1);
      }
      this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
        resp => {
          this.analystSearchResults.emit(resp);        }
      );
    }
    this.serviceProvidersService.setSelectedFilters(this.searchItems);
  }

  onServiceChange(event, serviceId) {
    this.searchItems.limit = this.limitCount;
    this.searchItems.offset = 0;
    if (event) {
      this.searchItems.serviceId.push(serviceId);
      this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
        resp => {
          this.analystSearchResults.emit(resp);
        }
      );
    } else {
      const index = this.searchItems.serviceId.indexOf(serviceId);
      if (index >= 0) {
        this.searchItems.serviceId.splice(index, 1);
      }
      this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
        resp => {
          this.analystSearchResults.emit(resp);
        }
      );
    }
    this.serviceProvidersService.setSelectedFilters(this.searchItems);
  }

  onIndustryChange(event, industryId) {
    this.searchItems.limit = this.limitCount;
    this.searchItems.offset = 0;
    if (event) {
      this.searchItems.industryId.push(industryId);
      this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
        resp => {
          this.analystSearchResults.emit(resp);
        }
      );
    } else {
      const index = this.searchItems.industryId.indexOf(industryId);
      if (index >= 0) {
        this.searchItems.industryId.splice(index, 1);
      }
      this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
        resp => {
          this.analystSearchResults.emit(resp);
        }
      );
    }
    this.serviceProvidersService.setSelectedFilters(this.searchItems);
  }

  onFocusAreaChange(event, focusAreaId) {
    this.searchItems.limit = this.limitCount;
    this.searchItems.offset = 0;
    if (event) {
      this.searchItems.focusAreaId.push(focusAreaId);
      this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
        resp => {
          this.analystSearchResults.emit(resp);
        }
      );
    } else {
      const index = this.searchItems.focusAreaId.indexOf(focusAreaId);
      if (index >= 0) {
        this.searchItems.focusAreaId.splice(index, 1);
      }
      this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
        resp => {
          this.analystSearchResults.emit(resp);
        }
      );
    }
    this.serviceProvidersService.setSelectedFilters(this.searchItems);
  }

  onRatingSelected(event) {
    this.searchItems.limit = this.limitCount;
    this.searchItems.offset = 0;
    this.searchItems.offset = 0;
    if (!event) {
      this.searchItems.rating = null;
    } else {
      this.latestRating = this.selectedRatings[this.selectedRatings.length - 1];
      this.searchItems.rating = this.latestRating;
    }
    this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
      resp => {
        this.analystSearchResults.emit(resp);
      }
    );
    this.selectedRatings.length = 0;
    this.selectedRatings.push(this.latestRating);
  }

  clearAllFilters() {
    this.searchItems.offset = 0;
    if (this.serviceOptions && this.serviceOptions.length !== 1) {
      this.selectedServiceOptions = [];
    }
    if (this.marketOptions && this.marketOptions.length !== 1) {
      this.selectedMarketOptions = [];
    }
    if (this.industryOptions && this.industryOptions.length !== 1) {
      this.selectedIndustryOptions = [];
    }
    if (this.focusAreaOptions && this.focusAreaOptions.length !== 1) {
      this.selectedFocusAreaOptions = [];
    }
    this.selectedRatings = [];
    this.latestRating = 0;
    this.searchItems.rating = null;
    this.searchItems.limit = this.limitCount;
    this.searchItems.filterType = this.selectedShowOptions;
    this.serviceProvidersService.getServiceProvidersList(this.searchItems).subscribe(
      resp => {
        this.analystSearchResults.emit(resp);
      }
    );
    this.searchItems.serviceId = [];
    this.searchItems.marketId = [];
    this.searchItems.industryId = [];
    this.searchItems.focusAreaId = [];
  }

  seeMoreValues(offerings) {
    switch (offerings) {
      case 'service':
        this.seeMoreServices = true;
        break;
      case 'market':
        this.seeMoreMarkets = true;
        break;
      case 'industry':
        this.seeMoreIndustries = true;
        break;
      case 'focusArea':
        this.seeMoreFocusAreas = true;
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/analyst-search/analyst-search-filters/analyst-search-filters.component.ts